import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type SendQueryStreamedDataInThreadSubscriptionSubscriptionVariables = Types.Exact<{
   threadId: Types.Scalars['Int']
}>

export type SendQueryStreamedDataInThreadSubscriptionSubscription = {
   __typename?: 'Subscription'
   sendQueryStreamedDataInThreadSubscription?: {
      __typename?: 'SendQueryStreamedDataInThreadResult'
      threadId: number
      response: string
   } | null
}

export const SendQueryStreamedDataInThreadSubscriptionDocument = gql`
   subscription SendQueryStreamedDataInThreadSubscription($threadId: Int!) {
      sendQueryStreamedDataInThreadSubscription(threadId: $threadId) {
         ... on SendQueryStreamedDataInThreadResult {
            threadId
            response
         }
      }
   }
`
export type SendQueryStreamedDataInThreadSubscriptionSubscriptionResult = Apollo.SubscriptionResult<
   SendQueryStreamedDataInThreadSubscriptionSubscription
>
